/*global _*/
<template>
    <div id="page-body" :class="formSchema.form.styleClassesBody">
        <!--LEGACY FORMGEN HEADER-->
        <div v-if="formSchema.form && !formSchema.form.hideHeader && _.get(formSchema.form, 'formType')!='formblank'" class="pageheader">
            <h1>{{ formSchema.form.title }}</h1>
            <div v-html="formSchema.form.text"></div>
        </div>

        <!--FORMGEN TOP-->
        <!--TODO MOVE TO LAYER BELOW-->

        <vue-form-generator :class="'vfg-top-debug ' + formSchema.form.styleClassesBody" v-if="_.get(formSchema.form, 'formType')=='formblank'" ref="form" :tag="formOrDiv" :schema="formSchema.pages[0].schema" :model="formSchema.model" :options="formSchema.options">
        </vue-form-generator>

        <!--LEGACY PAGES-->
        <component v-else id="formtop" :is="formOrDiv">
            <component v-on:ontabchange="onTabChange" ref="form" :formSchema="formSchema" :is="_.get(this.formSchema.form, 'formType')" :key="formSchema.id">
            </component>
        </component>
    </div>
</template>

<script>
    var debounce = require('debounce-promise')
    // import _ from 'lodash'
    import { app, scriptService } from 'Js/feathers';
    import { EventBus } from 'Js/eventBus';

    // import router from 'Js/routes.js';
    const router = () => import('Js/routes.js');
    import { actions } from 'Js/actionsProcessor';
    import { getQueryParams, rebuildReactivity, TranslateJSON } from 'Js/bfUtilities';
    // const getQueryParams = require('Js/bfUtilities').getQueryParams;

    var VueScrollTo = require('vue-scrollto');

    import Cleave from 'cleave.js'
    window.cleave = Cleave // todo move to app.vue ??
    import CleavePhone from 'cleave.js/dist/addons/cleave-phone.us';

    // Form Types
    Vue.component('formblank', require('./formblank.vue').default);
    Vue.component('formplain', require('./formplain.vue').default);
    Vue.component('formwizard', require('./formwizard.vue').default);
    Vue.component('formwidget', require('./formwidget.vue').default);

    // Custom Fields  TODO don't reg these as globals, but reg locally is fine.
    Vue.component('fieldFv_input', require('./custom/fv_input.vue').default);
    Vue.component('fieldFv_radios', require('./custom/fv_radios.vue').default);
    // Vue.component('fieldClearfix', require('./custom/clearfix.vue').default);
    Vue.component('fieldHtml', require('./custom/html.vue').default);
    Vue.component('fieldClearfix', require('./custom/clearfix.vue').default);
    Vue.component('fieldBfcheckbox1', require('./custom/bfcheckbox1.vue').default);

    //Testing code splitting for these components
    Vue.component('fieldButton', () =>
        import( /* webpackChunkName: "buttons" */ './custom/button.vue'));
    Vue.component('fieldButton2', () =>
        import( /* webpackChunkName: "buttons" */ './custom/button2.vue'));
    Vue.component('fieldBfcomponent', () =>
        import( /* webpackChunkName: "buttons" */ './custom/bfcomponent.vue'));

    // THESE ARE CODE SPLIT BELOW
    Vue.component('fieldHtmlDev', () =>
        import( /* webpackChunkName: "htmlDev" */ './custom/htmlDev.vue'));
    Vue.component('fieldAccordion', () =>
        import( /* webpackChunkName: "misc1" */ './custom/accordion.vue'));
    Vue.component('fieldAccordion2', () =>
        import( /* webpackChunkName: "misc1" */ './custom/accordion2.vue'));

    Vue.component('fieldVtabs', () =>
        import( /* webpackChunkName: "misc1" */ './custom/vtabs.vue'));
    Vue.component('fieldTabs_form2', () =>
        import( /* webpackChunkName: "misc1" */ './custom/tabs_form2.vue'));
    Vue.component('fieldListrows', () =>
        import( /* webpackChunkName: "misc1" */ './custom/listrows.vue'));
    Vue.component('fieldTabs_form', () =>
        import( /* webpackChunkName: "misc1" */ './custom/tabs_form.vue'));
    Vue.component('fieldTable2', () =>
        import( /* webpackChunkName: "misc1" */ './custom/table2.vue'));
    Vue.component('fieldPanel', () =>
        import( /* webpackChunkName: "misc1" */ './custom/panel.vue'));
    Vue.component('fieldDateRangePicker', () =>
        import( /* webpackChunkName: "misc1" */ './custom/dateRangePicker.vue'));

    Vue.component('fieldPaypal', () =>
        import( /* webpackChunkName: "paypal" */ './custom/paypal.vue'));
    Vue.component('fieldStripe', () =>
        import( /* webpackChunkName: "stripe" */ './custom/stripe.vue'));
    Vue.component('fieldAceeditor', () =>
        import( /* webpackChunkName: "aceeditor" */ './custom/aceeditor.vue'));
    Vue.component('fieldDropzone', () =>
        import( /* webpackChunkName: "dropzone" */ './custom/dropzone.vue'));
    Vue.component('fieldSignature', () =>
        import( /* webpackChunkName: "signature" */ './custom/signature.vue'));
    Vue.component('fieldQuilleditor', () =>
        import( /* webpackChunkName: "quill" */ './custom/quill.vue'));
    Vue.component('fieldGmap', () =>
        import( /* webpackChunkName: "gmap" */ './custom/googleMap.vue'));
    Vue.component('fieldFullCalendar', () =>
        import( /* webpackChunkName: "fullCalendar" */ './custom/fullCalendar.vue'));
    Vue.component('fieldAuthorize', () =>
        import( /* webpackChunkName: "authorize" */ './custom/authorize.vue'));
    Vue.component('fieldTiptap', () =>
        import( /* webpackChunkName: "tiptap" */ './custom/tiptap/tiptap.vue'));
    Vue.component('fieldUploadcare', () =>
        import( /* webpackChunkName: "uploadcare" */ './custom/uploadcare.vue'));

    export default {

        name: "formGenerator",

        methods: {

            // Validation Functions
            onFieldValidate: debounce(
                function(value, field, model) {
                    // everything in here is debounced
                    let payload = this.formSchema
                    payload.user = this.$store.state.auth.user
                    payload.validation = {
                        value: value,
                        field: field,
                        model: model
                    }
                    let myPromise = scriptService.create({
                            "service": "formsService.onFieldValidate",
                            "data": payload // send back everything just in case we need
                        })
                        .then(result => {
                            //TODO how to handle error prettier
                            if (_.get(result, 'error.errorCode')) {
                                BF.errorThrow(10300, 'Error from FMS onValidate', result)

                                alert('fms error: ', result.error)
                                return false
                            }

                            actions.queue(result.actions);
                            this.formSchema = result // ? result.formSchema : this.formSchema;
                            return (result.validation.error);
                        })
                        .catch(function(err) {
                            // handle error with an alert / error handler
                            alert('validation scriptServiceCallError : ' + err);
                            reject('validation-reject scriptServiceCallError: ' + err);
                        });
                    return myPromise
                },
                500
            ),

            onCustomValidate: (value, field, model) => {
                let app = vueapp.$store.state.site.content.app
                if (!field.validator_calc) {
                    return ["'validator_calc' key is not set for this field"]
                }
                let calc = field.validator_calc
                let errorMsg = field.errorMsg || "'errorMsg' key not set for this field"
                if (eval(calc)) {
                    return [];
                }
                else {
                    return [errorMsg];
                }
            },

            onDataFetch: function(query) {
                let payload = this.formSchema
                payload.user = this.$store.state.auth.user
                payload.query = query
                let params = {
                    "service": "formsService.onDataFetch",
                    "data": payload
                }
                let myPromise = this.callFms(params)
                    .then(result => {
                        if (_.get(result, 'error.errorCode')) {
                            alert('fms error (data Fetch): ', result.error.info)
                            return false
                        }
                        actions.queue(result.actions);
                        let data = result.data;
                        delete result.data;
                        this.formSchema = result // ? result.formSchema : this.formSchema;
                        return data
                    })
                    .catch(function(err) {
                        // handle error with an alert / error handler
                        reject('B- This is a custom validation error message.');
                    });

                return myPromise
            },

            onTabChange: function() {
                if (!this.formSchema.options.validateOnServer) {
                    return true
                }

                if (!this.$refs.form.validate()) {
                    return true || false
                }

                let payload = this.formSchema
                payload.user = this.$store.state.auth.user
                return new Promise((resolve, reject) => {
                    scriptService.create({
                            "service": "formsService.onTabChange",
                            "data": payload // send back everything just in case we need
                        })
                        .then(result => {

                            if (_.get(result, 'error.errorCode')) {
                                EventBus.$emit('toaster', {
                                    type: "Warning",
                                    title: "Data Load Error",
                                    msg: "There is an issue returning data : " + result.error,
                                    position: "toast-top-center"
                                });
                                reject(result.error);
                            }

                            result = TranslateJSON(result, this.idWndw);
                            Object.keys(result).forEach(function(key, index) {
                                _.isEmpty(result[key]) ? null : this.formSchema[key] = result[key];
                            }.bind(this));

                            actions.queue(result.actions);

                            if (result.state.allowTabChange) {

                                var cancelScroll;
                                var options = {
                                    container: "body",

                                    easing: [0.68, .8, 0.265, 1.55],
                                    // duration: 1500,
                                    offset: 0,
                                    cancelable: true,
                                    onDone: function() {
                                        // scrolling is done
                                    },
                                    onCancel: function() {
                                        // scrolling has been interrupted
                                    },
                                    x: false,
                                    y: true
                                }
                                if (_.get(result, "form.scrolling") == undefined) {
                                    // scroll as normal
                                    cancelScroll = VueScrollTo.scrollTo("#main-wrapper", 500, options)
                                }
                                else if (_.isEmpty(_.get(result, "form.scrolling"))) {
                                    // defined as {} so no scroll at all
                                }
                                else {
                                    cancelScroll = VueScrollTo.scrollTo("#main-wrapper", result.form.scrolling.options.duration || 500, Object.assign(options, result.form.scrolling.options))
                                }
                                resolve(true)
                            }
                            else {
                                // result.state.TabChangeError = "state.tabChangeError message"
                                reject(result.state.tabChangeError);
                            }

                        })
                        .catch(function(error) {
                            reject(error);
                        });
                })
            },

            onUtilityHook: function(hookPackage) {
                // if (!this.$store.getters.isOnline()) return;
                var payload = Object.assign({}, this.formSchema)
                if (!payload.form.sendFullSchema) {
                    delete payload.pages
                    delete payload.options
                    delete payload.site
                    delete payload.form
                    delete payload.modelCaches
                    payload.form = {}
                    payload.form.hookSetName = this.formSchema.form.hookSetName
                }
                delete hookPackage.function
                if (hookPackage.options.model || hookPackage.options.modelFilterKeys) {
                    _.set(payload, 'state.modelUpdateMode', 'merge')
                }
                hookPackage.options.model ? payload.model = hookPackage.options.model : null
                hookPackage.options.modelFilterKeys ? payload.model = _.pick(payload.model, hookPackage.options.modelFilterKeys) : null
                delete hookPackage.options.modelFilterKeys
                payload.hookPackage = hookPackage
                payload.query = hookPackage.options.query || getQueryParams()
                let params = {
                    "service": "formsService.onUtility",
                    "data": payload
                }

                this.callFms(params) // returns a promise
                    .then(function(result) {
                        if (result.code) { throw result }

                        if (_.get(result, 'error.errorCode')) {
                            //Send to error handler
                            alert('fms error (onUtilityHook): ', result.error.info)
                            return false
                        }

                        this.$store.commit('SET_APP', result.app);
                        delete result.app;

                        actions.queue({ actions: result.actions, idThread: hookPackage.idThread, insert: true, idForm: hookPackage.idForm });

                        delete result.actions;
                        // CD - why is this checking window[0] ??
                        if ((this.$store.state.wndw.windows[0].formSchema.id === hookPackage.idForm) && hookPackage.idForm) {
                            _.get(result, 'state.modelUpdateMode') == 'merge' ?
                                result.model = Object.assign(this.formSchema.model, result.model) :
                                null
                            delete result.state.modelUpdateMode

                            delete result.form
                            if (!_.isEmpty(result.pages) && !_.isEqual(this.formSchema.pages, result.pages)) {
                                this.formSchema.pages = result.pages
                            }

                            delete result.pages

                            if (!_.isEmpty(result.options)) {
                                this.formSchema.options = result.options
                                delete result.options
                            }

                            Object.keys(result).forEach(function(key, index) {
                                _.isEmpty(result[key]) ? null : this.formSchema[key] = result[key]
                            }.bind(this));

                            return result
                        }
                        return result;

                    }.bind(this))
                    .then(result => {
                        result = TranslateJSON(result, this.idWndw);
                        return result
                    })
                    .catch(e => {
                        BF.errorThrow(e);
                        return false;
                    })
            },


            onComplete: function() {
                // call child validate method
                if (!this.$refs.form.validate()) {
                    return false
                }

                // if actions set then do, else run
                if (typeof this.formSchema.form.wizardOnComplete === "function") {
                    this.formSchema.form.wizardOnComplete()
                    return
                }

                let payload = this.formSchema
                payload.user = this.$store.state.auth.user
                return new Promise((resolve, reject) => {
                    let myPromise = scriptService.create({
                            "service": "formsService.onComplete",
                            "data": payload // send back everything just in case we need
                        })
                        .then(result => {
                            // actions.queue(result.actions);
                            this.$store.dispatch('ACTIONS_QUEUE', result.actions);
                            this.formSchema = result
                            // maybe add a default action if no action passed
                            if (!result.actions) {
                                router.push("/")
                            }
                            // return 
                            resolve(true)
                        })
                        .catch(function(error) {
                            // handle error with an alert / error handler
                            EventBus.$emit('toaster', {
                                type: "Warning",
                                title: "Data Load Error",
                                msg: "There is an issue returning data: " + error,
                                position: "top-center"
                            })
                            reject(error)
                        });
                })

            },

            callFms: function(params) {
                let myPromise = scriptService.create(params)
                    .then(result => {
                        return result;
                    })
                    .catch(function(error) {
                        return error;
                    });
                return myPromise;
            },

            processNamedAction: function(namedAction) {
                //idThread should be on higher level, not under options
                let actionsObj = _.get(this, 'formSchema.form.namedActions[' + namedAction.name + ']')
                actionsObj = actionsObj || _.get(this.$store.state.site, 'content.namedActions.' + namedAction.name)

                if (!actionsObj && (namedAction.name === 'appIsOnline' || namedAction.name === 'appIsOffline')) {
                    return;
                }

                if (!actionsObj) {
                    namedAction.idThread ? this.$store.commit('SET_PENDINGTRHEADS', namedAction.idThread) : null;
                    BF.errorThrow(10110, `namedAction ${namedAction.name} was not found for action `, namedAction)
                    return
                }

                var actionsArray = []
                Array.isArray(actionsObj) ? actionsArray = actionsObj : actionsArray.push(actionsObj)
                actionsArray = _.cloneDeep(actionsArray);

                var idThread = namedAction.idThread ? namedAction.idThread : Date.now();

                // mix in options
                for (var i = 0, len = actionsArray.length; i < len; i++) {
                    actionsArray[i].options ? null : actionsArray[i].options = {}
                    actionsArray[i].options = Object.assign(actionsArray[i].options, namedAction.options || {})
                    actionsArray[i].idThread = idThread
                }

                // this.processActions(actionsArray);
                this.$store.dispatch('ACTIONS_QUEUE', {
                    actions: actionsArray,
                    insert: true,
                    idThread: idThread
                });

            },

            processActions: function(actionsObj) {
                // expects: {} or  []
                var actionsArray = []
                if (Array.isArray(actionsObj)) {
                    actionsArray = actionsObj
                }
                else {
                    actionsArray.push(actionsObj)
                }

                actions.queue(actionsArray);
            },

            doValidation: function(action) {
                let result = this.$refs.form.validate()
                if (result) {
                    actions.process(action)
                }
                else {
                    this.$store.dispatch('ACTIONS_CLEAR', action);
                    typeof action.onFailed === "function" ? action.onFailed() : null
                }
            },

            processWidgetPayload: function(payload) {
                this.formSchema.model = Object.assign({}, this.formSchema.model, payload.model)
            },

            executeFunction: function(action) {
                if (action.function) {
                    try {
                        var params1 = this.$store.state.site.content.params || {}
                        var app1 = this.$store.state.site.content.app
                        var funct = Function('formSchema', 'model', 'action', 'app', 'params', 'args', 'EventBus', action.function)
                        var result = funct(this.formSchema, this.formSchema.model, action, app1, params1, _.get(action, 'options.args'), EventBus)
                        this.$store.commit('SET_PARAMS', params1);
                        this.$store.commit('SET_APP', app1);
                        BF.rebuildReactivity(this.formSchema.model)
                    }
                    catch (error) {
                        BF.errorThrow(error);
                    }

                }
            },

            clearListeners: function() {
                var events = ['runUtilityHook', 'onDataFetch', 'runOnCompleteHook', 'processNamedAction', 'validate',
                    'processWidgetPayload', 'processActions', 'executeFunction'
                ]
                var _this = this
                events.forEach(function(event) {
                    // console.log('Cearing lister: ' + event + '_' + _this._uid )
                    EventBus.$off(event, _this.listners[event + '_' + _this._uid])
                });

            }
        },

        created() {
            window.formGen = this // this allows the this to be accessed from some 
            this.formSchema = this.formSource
        },

        beforeMount() {},

        mounted() {
            // this.formSchema = this.formSource
            var _this = this

            // register EventBus func's
            const busReg = (event, cb) => {
                // register a unique event
                var name = event + '_' + _this._uid
                var fn = function(arg) {
                    // check if the event came from this wndw else return
                    if (
                        _this.$store.getters.getActiveWindow == _this.formSchema.options.idWndw
                        // !activeWndw || // no activeW
                        // arg.idWndw == thisIdWndw || // no active but intented for this windw?
                        // (activeWndw.id == thisIdWndw && arg.idWndw == undefined) // has id but not explicitly set
                    ) {
                        var args = []
                        //Check if actions is being passed up
                        args[0] = arg ? (arg.payload || arg) : null
                        cb.apply(_this, args)
                    }
                }

                // console.log('creating listers: ', name )
                Object.defineProperty(fn, "name", { value: name });
                _this.listners[name] = fn
                EventBus.$on(event, fn);
            };

            // Set up Custom Validators
            window.VueFormGenerator.validators.fmsHook = this.onFieldValidate
            window.VueFormGenerator.validators.calc = this.onCustomValidate

            busReg('onDataFetch', (query, done) => {
                let result = this.onDataFetch(query)
                    .then(result => {
                        done(result)
                    })
            });
            busReg('runUtilityHook', this.onUtilityHook);
            busReg('runOnCompleteHook', this.onComplete);
            busReg('processNamedAction', this.processNamedAction);
            busReg('validate', this.doValidation);
            busReg('processWidgetPayload', this.processWidgetPayload);
            busReg('executeFunction', this.executeFunction);
            busReg('processActions', this.processActions);

        },

        beforeDestroy() {
            this.clearListeners()
        },

        destroyed() {},

        props: {
            formSource: {
                type: Object
            },
            loading: {
                type: Boolean
            },
            idWndw: {
                default: 0,
                type: Number
            }
        },

        computed: {

            theModel: function() {
                return this.formSchema.model
            },

            formOrDiv: function() {
                return this.formSchema.form && this.formSchema.form.isForm ? 'form' : 'div'
            },

            slots: function() {
                return _.get(this.formSchema, 'form.slots') || []
            },
        },

        data: function() {
            return {
                formSchema: {},
                // schemaStore: {},
                listners: {} // holds event wrappers
            }
        }

    }
</script>

<style src="../../../css/vfg.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.min.css"></style>

.multiselect--active { z-index: 10; }

</style>
<style>
</style>
